import { render, staticRenderFns } from "./index.vue?vue&type=template&id=bc2d8efa&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=bc2d8efa&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc2d8efa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Workplace\\vueProject\\edu_aim\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc2d8efa')) {
      api.createRecord('bc2d8efa', component.options)
    } else {
      api.reload('bc2d8efa', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=bc2d8efa&scoped=true", function () {
      api.rerender('bc2d8efa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/home/index.vue"
export default component.exports